var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid mt-1 mb-3"},[_c('crypto-widget',{attrs:{"type":"ticker-quotes","template":"chart","color":"grey","assets":"BTC~USD,ETH~USD,LTC~USD,DASH~USD,XRP~USD,USDT~USD,ETC~USD,BTG~USD,XMR~USD","speed":"30","direction":"left","pause":"true","api":"cryptocompare.com","realtime":"true","animation":"zoomInLeft"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }